import { render, staticRenderFns } from "./request-change.vue?vue&type=template&id=15246dd6&"
import script from "./request-change.vue?vue&type=script&lang=js&"
export * from "./request-change.vue?vue&type=script&lang=js&"
import style0 from "./request-change.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports